import * as React from "react";
import { Button, Chip } from "@mui/material";
import { Faders } from "@phosphor-icons/react";

import { useAdvancedFilters } from "@/hooks/use-advanced-filters";

import { FieldType } from "../dynamicField/types";
import { AdvancedFiltersDrawer } from "./advanced-filters-drawer";
import { FilterCondition } from "./types";

interface AdvancedFilterButtonProps {
	conditions: FilterCondition[];
	setConditions: (conditions: FilterCondition[]) => void;
	availableFields: FieldType[];
	disabled?: boolean;
}

export function AdvancedFilterButton({
	availableFields,
	setConditions,
	disabled = false,
	conditions = [],
}: AdvancedFilterButtonProps): React.JSX.Element {
	const { isDrawerOpen, openDrawer, closeDrawer, applyFilters, resetFilters } = useAdvancedFilters({
		conditions,
		setConditions,
	});

	const conditionsCount = conditions.length;

	return (
		<>
			<Button
				startIcon={<Faders />}
				variant="outlined"
				color="secondary"
				onClick={openDrawer}
				disabled={disabled}
				sx={{ position: "relative" }}
			>
				Filters
				{conditionsCount > 0 && (
					<Chip
						label={conditionsCount}
						size="small"
						color="primary"
						sx={{
							position: "absolute",
							right: -8,
							top: -4,
							height: 16,
							minWidth: 16,
							fontSize: "10px",
							"& .MuiChip-label": {
								px: 0.5,
							},
						}}
					/>
				)}
			</Button>

			<AdvancedFiltersDrawer
				open={isDrawerOpen}
				onClose={closeDrawer}
				onReset={resetFilters}
				onApply={applyFilters}
				conditions={conditions}
				availableFields={availableFields}
			/>
		</>
	);
}
